export enum BalloonStatus {
  IDLE       = 'idle',
  READY      = 'ready',
  PREHEATING = 'preheating',
  HEATING    = 'heating',
  PAUSED     = 'paused',
  WON        = 'won',
  BUSTED     = 'busted',
}

export interface BalloonResult {
  cashoutMultiplier: number;
  payout: number;
  crashPoint: number;
  serverSeed: string;
  clientSeed: string;
}

export interface BalloonState {
  /** Game lifecycle status. 'idle' = no active game. */
  status: BalloonStatus;

  /** Set while game is active */
  betAmount: number | null;
  currency: string | null;
  serverSeedHash: string | null;

  /** Latest multiplier from server (updated at ~25 Hz) */
  multiplier: number;

  /** Milliseconds remaining in pause countdown (null when not paused) */
  pauseRemainingMs: number | null;

  /** Filled when game ends */
  result: BalloonResult | null;

  /** True while waiting for balloon_start acknowledgement */
  loading: boolean;
}
